/* ============================================================
   Véloria Piercing — Bundle « 2 achetés = le 3ᵉ offert »
   Reflète le panier réel (/cart.js) · vraies images produits
   Un seul trio (max 3 articles), le moins cher offert.
   ============================================================ */
(function () {
  if (window.__vBundleInit) return;
  window.__vBundleInit = true;
  window.__vBundleVer = 'r8';

  var MAX = 3;
  var SPARK = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2l1.9 5.9L20 9.8l-5.1 2.9L12 19l-2.9-6.3L4 9.8l6.1-1.9z"/></svg>';

  var TXT = {
    start: 'Ajoutez un premier bijou pour lancer votre trio.',
    one:   'Encore 2 bijoux pour débloquer votre cadeau.',
    two:   'Plus qu’un bijou… votre article offert vous attend.',
    win:   'Cadeau débloqué — vous économisez'
  };

  var st = { units: [], slots: null, fetchSeq: 0, debTimer: null, booted: false, fmt: '{{amount}} €' };

  function bundles() { return [].slice.call(document.querySelectorAll('[data-v-bundle]')); }

  /* ---- Shopify money formatting ---- */
  function formatMoney(cents, format) {
    var fmt = format || '{{amount}} €';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function fwd(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cts = parts[1] ? decimal + parts[1] : '';
      return dollars + cts;
    }
    var m = fmt.match(re);
    var ph = m ? m[1] : 'amount';
    var val;
    switch (ph) {
      case 'amount': val = fwd(cents, 2); break;
      case 'amount_no_decimals': val = fwd(cents, 0); break;
      case 'amount_with_comma_separator': val = fwd(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = fwd(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': val = fwd(cents, 2, ' ', ','); break;
      case 'amount_with_apostrophe_separator': val = fwd(cents, 2, "'", '.'); break;
      default: val = fwd(cents, 2);
    }
    return fmt.replace(re, val);
  }
  function money(cents) { return formatMoney(cents, st.fmt); }

  /* ---- image url with a thumbnail width ---- */
  function thumb(url, size) {
    if (!url) return '';
    return url.indexOf('?') > -1 ? url + '&width=' + size : url + '?width=' + size;
  }

  /* ---- cart.js -> toutes les unités disponibles (clé stable par unité) ---- */
  function cartToAvailable(cart) {
    var arr = [];
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var q = it.quantity || 1;
      /* prix produit normal (avant remise) : la remise « 2+1 » met final_price à 0
         sur le moins cher — on affiche toujours le vrai prix barré. */
      var price = (it.original_price != null) ? it.original_price : it.price;
      var img = it.image || (it.featured_image && it.featured_image.url) || '';
      /* identité STABLE = id de variante : la remise « 2+1 » re-hashe la clé de
         ligne (it.key) à chaque mutation, mais l'id de variante ne change pas. */
      var vid = '' + (it.id || it.variant_id || it.key);
      for (var k = 0; k < q; k++) {
        arr.push({
          key: vid + '#' + k,
          price: price,
          img: thumb(img, 220),
          title: it.product_title || it.title || ''
        });
      }
    }
    return arr;
  }

  /* ---- trio VERROUILLÉ : une fois les 3 emplacements remplis, ils restent figés
     (persistés entre les fiches produits). Ajouter un 4e/5e/6e article ne remplace
     donc jamais le trio ni l'article offert. ---- */
  var SLOT_KEY = 'vBundleTrioV2';
  function initSlots() {
    if (st.slots) return;
    try {
      var a = JSON.parse(sessionStorage.getItem(SLOT_KEY));
      st.slots = (a && a.length === MAX) ? a : [null, null, null];
    } catch (e) { st.slots = [null, null, null]; }
  }
  function saveSlots() { try { sessionStorage.setItem(SLOT_KEY, JSON.stringify(st.slots)); } catch (e) {} }

  function resolveTrio(avail) {
    initSlots();
    var map = {}; avail.forEach(function (u) { map[u.key] = u; });
    var slots = st.slots;
    /* 1. libérer les emplacements dont l'article a quitté le panier */
    for (var i = 0; i < MAX; i++) { if (slots[i] && !map[slots[i]]) slots[i] = null; }
    /* 2. articles déjà placés */
    var assigned = {}; for (var a = 0; a < MAX; a++) { if (slots[a]) assigned[slots[a]] = 1; }
    /* 3. articles pas encore placés (dans l'ordre du panier) */
    var pending = avail.filter(function (u) { return !assigned[u.key]; });
    /* 4. remplir uniquement les emplacements vides — sans toucher aux remplis */
    for (var j = 0; j < MAX; j++) {
      if (!slots[j] && pending.length) { var u = pending.shift(); slots[j] = u.key; assigned[u.key] = 1; }
    }
    saveSlots();
    /* 5. unités remplies, compactées dans l'ordre des emplacements */
    var filled = [];
    for (var m = 0; m < MAX; m++) { if (slots[m] && map[slots[m]]) filled.push(map[slots[m]]); }
    return filled;
  }

  /* ---- display order: cheapest last once complete ---- */
  function displayOrder(units) {
    if (units.length < MAX) return { arr: units.slice(), done: false, cheapest: null };
    var ci = 0;
    for (var i = 1; i < units.length; i++) if (units[i].price < units[ci].price) ci = i;
    var cheap = units[ci];
    var rest = units.filter(function (u, i) { return i !== ci; });
    return { arr: rest.concat([cheap]), done: true, cheapest: cheap };
  }

  /* Rendu IDEMPOTENT : recalcule l'état complet et le peint. Appeler plusieurs
     fois avec le même panier produit exactement le même DOM (aucune animation
     rejouée, aucun compteur fragile) — robuste aux mises à jour concurrentes. */
  function renderState(animate) {
    var disp = displayOrder(st.units);
    var count = st.units.length;
    bundles().forEach(function (b) {
      var wasComplete = b.classList.contains('is-complete');
      b.setAttribute('data-count', count);
      b.classList.toggle('is-complete', disp.done);

      var chip = b.querySelector('.v-bundle__count');
      if (chip) { chip.textContent = count + '/' + MAX; chip.classList.toggle('is-done', disp.done); }

      var bar = b.querySelector('.v-bundle__progress i');
      if (bar) { bar.style.width = (count / MAX * 100) + '%'; bar.classList.toggle('is-done', disp.done); }

      var slots = b.querySelectorAll('.v-bundle__slot');
      for (var i = 0; i < MAX; i++) {
        var s = slots[i]; if (!s) continue;
        var u = disp.arr[i];
        var imgWrap = s.querySelector('.v-bundle__img');
        var price = s.querySelector('.v-bundle__price');
        var curKey = s.getAttribute('data-unit') || '';
        var newKey = u ? u.key : '';
        if (u) {
          if (curKey !== newKey) {
            if (imgWrap) imgWrap.innerHTML = '<img src="' + u.img + '" alt="" loading="lazy">';
            s.setAttribute('data-unit', newKey);
            /* pop uniquement sur un remplissage neuf (emplacement était vide) */
            if (animate && !curKey) { s.classList.remove('v-pop'); void s.offsetWidth; s.classList.add('v-pop'); }
          }
          s.classList.add('is-filled');
          if (disp.done && i === MAX - 1) {
            s.classList.add('is-free');
            if (price) price.innerHTML = '<s>' + money(u.price) + '</s>';
          } else {
            s.classList.remove('is-free');
            if (price) price.textContent = money(u.price);
          }
        } else {
          if (curKey) { if (imgWrap) imgWrap.innerHTML = ''; s.removeAttribute('data-unit'); }
          if (price) price.textContent = '';
          s.classList.remove('is-filled', 'is-free', 'v-pop');
        }
      }

      var status = b.querySelector('.v-bundle__status');
      if (status) {
        status.classList.remove('is-win');
        if (count === 0) status.textContent = TXT.start;
        else if (count === 1) status.innerHTML = SPARK + ' ' + TXT.one;
        else if (count === 2) status.innerHTML = SPARK + ' ' + TXT.two;
        else {
          status.classList.add('is-win');
          status.innerHTML = SPARK + ' ' + TXT.win + ' <span class="v-bundle__save">' + money(disp.cheapest.price) + '</span>.';
        }
      }

      /* révélation « cadeau débloqué » : balayage doré une seule fois */
      if (animate && disp.done && !wasComplete) {
        b.classList.remove('v-shine'); void b.offsetWidth; b.classList.add('v-shine');
        (function (bb) { setTimeout(function () { bb.classList.remove('v-shine'); }, 1100); })(b);
      }
    });
  }

  function update(cart, animate) {
    st.units = resolveTrio(cartToAvailable(cart));
    renderState(!!animate);
  }

  /* jeton de requête : seule la réponse /cart.js la plus récente peut peindre
     (évite qu'une réponse périmée écrase un état plus récent). */
  function fetchCart(animate) {
    var token = ++st.fetchSeq;
    return fetch('/cart.js?_=' + Date.now(), { cache: 'no-store', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (token === st.fetchSeq) update(c, animate); })
      .catch(function () {});
  }
  /* debounce : coalesce les changements rapprochés en une seule mise à jour. */
  function scheduleFetch(animate) {
    clearTimeout(st.debTimer);
    st.debTimer = setTimeout(function () { fetchCart(animate); }, 170);
  }

  /* ---- détection des changements de panier (thème-agnostique) ---- */
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?/;
  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function () {
      var a = arguments;
      var url = (a[0] && a[0].url) ? a[0].url : ('' + a[0]);
      var p = _fetch.apply(this, a);
      if (CART_RE.test(url)) p.then(function () { scheduleFetch(true); }).catch(function () {});
      return p;
    };
  }
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) { this.__vUrl = url; return _open.apply(this, arguments); };
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__vUrl && CART_RE.test(this.__vUrl)) {
      this.addEventListener('load', function () { scheduleFetch(true); });
    }
    return _send.apply(this, arguments);
  };
  ['cart:updated', 'cart:refresh', 'cartUpdate', 'cart:change'].forEach(function (ev) {
    document.addEventListener(ev, function () { scheduleFetch(true); });
  });

  function readConfig() {
    var el = bundles()[0];
    if (el && el.getAttribute('data-money-format')) st.fmt = el.getAttribute('data-money-format');
  }
  function boot() {
    if (st.booted) return; st.booted = true;
    initSlots();
    readConfig();
    fetchCart(false);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
